import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'awo-care-back-to-home',
  standalone: true,
  imports: [RouterModule],
  template: `
    <!--
      Bewusst <div> statt <nav>: ein einzelner Link ist kein
      Navigations-Bereich. Als <nav> ohne aria-label erzeugte er auf jeder
      Rechtsseite eine zweite, unbenannte navigation-Landmarke direkt neben
      der Hauptnavigation — Screenreader listen dann zwei gleich benannte
      Bereiche auf.
    -->
    <div class="back-navigation">
      <a routerLink="/" class="back-to-home-link">
        <span aria-hidden="true">←</span>
        <span i18n="@@legal.backToHome">Zurück zur Startseite</span>
      </a>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .back-navigation {
      margin-top: 3rem;
      padding-top: 2rem;
      border-top: 1px solid var(--mat-app-outline-variant, #e0e0e0);
    }
  `],
})
export class BackToHomeComponent {}
